import get from 'lodash.get';
import { create } from 'services/api';

const RECEIVE_AVAILABLE = 'create/integrations/RECEIVE_AVAILABLE';
const RECEIVE_ENABLED = 'create/integrations/RECEIVE_ENABLED';

const alwaysAvailableIntegrations = ['apple'];

export const selectAvailableIntegrations = state =>
  get(state, ['v2', 'integrations', 'available'], null);
export const selectEnabledIntegrations = showId => state =>
  get(state, ['v2', 'integrations', 'enabled', showId], null);

const initialState = {
  available: null,
  enabled: {},
};
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_AVAILABLE:
      return {
        ...state,
        available: [...alwaysAvailableIntegrations, ...action.payload],
      };
    case RECEIVE_ENABLED: {
      const { id, items } = action.payload || {};
      return {
        ...state,
        enabled: {
          ...state.enabled,
          [id]: items,
        },
      };
    }
    default:
      return state;
  }
}

export const fetchAvailableIntegrations = () => (dispatch, getState) => {
  if (selectAvailableIntegrations(getState())) {
    return Promise.resolve();
  }
  return create.get('/api-v3/integrations').then(response => {
    dispatch({ type: RECEIVE_AVAILABLE, payload: get(response, ['body', 'items'], null) });
    return Promise.resolve();
  });
};

export const fetchEnabledIntegrations = showId => (dispatch, getState) => {
  if (selectEnabledIntegrations(showId)(getState())) {
    return Promise.resolve();
  }
  return create.get(`/api-v3/shows/${showId}/integrations`).then(response => {
    dispatch({ type: RECEIVE_ENABLED, payload: get(response, ['body'], null) });
    return Promise.resolve();
  });
};
